// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TSearchOffersForHouseCardDesktopRequest,
  TSearchOffersForHouseCardDesktopModel,
  IMappers,
  TSearchOffersForHouseCardDesktopResponse_,
  TSearchOffersForHouseCardDesktopResponse,
  TSearchOffersForHouseCardDesktopResponse_1,
  TSearchOffersForHouseCardDesktopResponseError,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';

export function createSearchOffersForHouseCardDesktopModel(
  parameters: TSearchOffersForHouseCardDesktopRequest,
): TSearchOffersForHouseCardDesktopModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'search-offers',
    pathApi: '/v1/search-offers-for-house-card-desktop/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface ISearchOffersForHouseCardDesktopOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TSearchOffersForHouseCardDesktopRequest;
}

export async function fetchSearchOffersForHouseCardDesktop<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: ISearchOffersForHouseCardDesktopOptions<TResponse200, TResponse400>): Promise<
  TSearchOffersForHouseCardDesktopResponse | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createSearchOffersForHouseCardDesktopModel(parameters),
    config,
  )) as FetchResponse<TSearchOffersForHouseCardDesktopResponse_>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as TSearchOffersForHouseCardDesktopResponse_1, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as TSearchOffersForHouseCardDesktopResponseError, headers);
    }
  }
  return {
    statusCode,
    response,
    headers: Array.from(headers),
  } as TSearchOffersForHouseCardDesktopResponse;
}
